var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "title h2",
      attrs: { itemprop: "url", href: _vm.lodging.url },
    },
    [
      _vm.showNew
        ? _c("div", { staticClass: "newHouseArea" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.displaySchema === false
        ? [_vm._v("\n\t\t" + _vm._s(_vm.lodging.postMeta.esAddress1) + "\n\t")]
        : _c(
            "span",
            {
              attrs: {
                itemprop: "address",
                itemscope: "",
                itemtype: "https://schema.org/PostalAddress",
              },
            },
            [
              _c("span", { attrs: { itemprop: "streetAddress" } }, [
                _vm._v(_vm._s(_vm.lodging.postMeta.esAddress1)),
              ]),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  itemprop: "postalCode",
                  content: _vm.lodging.postMeta.esPostalCode,
                },
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  itemprop: "addressLocality",
                  content: _vm.lodging.postMeta.esCity,
                },
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: { itemprop: "addressCountry", content: "DK" },
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  itemprop: "alternateName",
                  content: _vm.lodging.postMeta.esAddress2,
                },
              }),
            ]
          ),
      _vm._v("\n\t("),
      _c("span", { attrs: { itemprop: "identifier" } }, [
        _vm._v(_vm._s(_vm.lodging.postMeta.esName)),
      ]),
      _vm._v(")\n"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "new-label" }, [
      _vm._v("Ny"),
      _c("div", { staticClass: "newHover" }, [_vm._v("Nyt hos Esmark")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }